import styled from '@emotion/styled';
import { color } from '@shared/constants/Styles';
import Card from '../card/LegacyCard';

const ActionCardWrapper = styled(Card)`
    border: 1px solid ${color.secondary_light};
    box-shadow: none;
    display: flex;
    overflow: visible;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-width: 380px;
    max-width: 800px;
    width: 100%;
    padding: 16px;
    background-color: ${(props) => props.theme.color.background};
    color: ${(props) => props.theme.color.text};
    > * {
        margin: 8px 16px;
    }
`;
export default ActionCardWrapper;
